import { Injectable } from '@angular/core';
import { LocalStorageKeyEnum } from '@shared/enums/local-storage-key.enum';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  protected readonly localStorage: Storage = window.localStorage;

  setItem(key: LocalStorageKeyEnum, value: string): void {
    this.localStorage.setItem(key, value);
  }

  getItem(key: LocalStorageKeyEnum): string {
    return this.localStorage.getItem(key);
  }

  removeItem(key: LocalStorageKeyEnum): void {
    this.localStorage.removeItem(key);
  }

  clear(): void {
    this.localStorage.clear();
  }
}
